import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Service } from 'src/app/services/interface';
import { ServicesService } from 'src/app/services/services.service';
import { CountryStateService } from 'src/app/_services/country.service';
import { ServiceFormService } from '../service-form.service';

@Component({
  selector: 'app-service-overview',
  templateUrl: './service-overview.component.html',
  styleUrls: ['./service-overview.component.scss']
})
export class ServiceOverviewComponent implements OnInit {
  public service: Service;
  public categories$ = this.servicesService.serviceCategories$
  public serviceProviders$ = this.servicesService.serviceProviders$
  public unitsOfMeasure$ = this.servicesService.unitsOfMeasure$
  countries$ = this.countryService.countries$;

  constructor(
    private route: ActivatedRoute,
    private servicesService: ServicesService,
    private serviceFormService: ServiceFormService,
    private countryService: CountryStateService
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.service = data.serviceDetails;
    })
    this.servicesService.getServiceCategories().subscribe()
    this.servicesService.getServiceProviders().subscribe()
    this.servicesService.getUnitsOfMeasure().subscribe()
    this.countryService.getCountries().subscribe();
  }

  public get serviceFormGroup() {
    return this.serviceFormService.serviceFormGroup
  }

  public get tagsControl() {
    return this.serviceFormGroup.controls.tags as FormControl
  }
}
